module.exports = __webpack_public_path__ + "img/3-1.bd06ea5e.jpg";